import { Expose } from 'class-transformer';

export default class AcceptInvitationFormError {
  first_name: string[] = []
  last_name: string[] = []
  code: string[] = []
  @Expose({ name: '_schema' }) schema: string[] = []
}